"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubLegendItem = exports.LegendItem = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _dist = require("kubra-ux/dist");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var LegendItem = function LegendItem(props) {
  var toggleable = props.toggleable,
      icon = props.icon,
      name = props.name,
      onToggle = props.onToggle,
      value = props.value,
      id = props.id;

  var toggleHandler = function toggleHandler() {
    if (onToggle) {
      onToggle(!value);
    }
  }; // console.log(icon);


  return /*#__PURE__*/_react.default.createElement("div", {
    id: id,
    className: 'legend-item'
  }, toggleable ? /*#__PURE__*/_react.default.createElement(_dist.Checkbox, {
    disabled: false,
    checked: value,
    id: "".concat(id, "-checkbox"),
    label: '',
    useLight: false,
    onChange: toggleHandler
  }) : /*#__PURE__*/_react.default.createElement("div", {
    id: 'checkbox-holder'
  }, "\xA0"), icon && /*#__PURE__*/_react.default.createElement("div", {
    className: 'legend-icon'
  }, icon), /*#__PURE__*/_react.default.createElement("span", {
    className: 'legend-item-label'
  }, name));
};

exports.LegendItem = LegendItem;
LegendItem.propTypes = {
  toggleable: _propTypes.default.bool,
  icon: _propTypes.default.node,
  name: _propTypes.default.string.isRequired,
  onToggle: _propTypes.default.func,
  value: _propTypes.default.bool,
  id: _propTypes.default.string
};

var SubLegendItem = function SubLegendItem(props) {
  var toggleable = props.toggleable,
      icon = props.icon,
      name = props.name,
      onToggle = props.onToggle,
      value = props.value,
      id = props.id;

  var toggleHandler = function toggleHandler() {
    if (onToggle) {
      onToggle(!value);
    }
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    id: id,
    className: 'sub-legend-item'
  }, toggleable ? /*#__PURE__*/_react.default.createElement(_dist.Checkbox, {
    disabled: false,
    checked: value,
    id: "".concat(id, "-checkbox"),
    label: '',
    useLight: false,
    onChange: toggleHandler
  }) : /*#__PURE__*/_react.default.createElement("div", {
    id: 'checkbox-holder'
  }, "\xA0"), icon && /*#__PURE__*/_react.default.createElement("div", {
    className: 'legend-icon'
  }, icon), /*#__PURE__*/_react.default.createElement("span", {
    className: 'legend-item-label'
  }, name));
};

exports.SubLegendItem = SubLegendItem;
SubLegendItem.propTypes = {
  toggleable: _propTypes.default.bool,
  icon: _propTypes.default.node,
  name: _propTypes.default.string.isRequired,
  onToggle: _propTypes.default.func,
  value: _propTypes.default.bool,
  id: _propTypes.default.string
};